define({
	popupTriggerLabel: "Mostrar o esconder columnas",
	popupLabel: "Mostrar o esconder columnas"
});
